export default __webpack_public_path__ + "static/media/intro.24692de0.wav";